import Vue from 'vue';
import MetaInfo from 'vue-meta-info';
import App from './App.vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/base.css';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/iconfont.css';
import router from './router';
import store from './store';
import './registerServiceWorker';
import { HappyScroll } from 'vue-happy-scroll'
import VideoPlayer from 'vue-video-player'
import api from '../src/common/api'
// 引入 swiper 轮播图组件
import 'swiper/css/swiper.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
// 引入 jquery
// import $ from 'jquery'
// window.jquery = window.$ = $

Vue.use(VueAwesomeSwiper);
// window.videojs = VideoPlayer.videojs
// require('video.js/dist/video-js.css')
// require('vue-video-player/src/custom-theme.css')
// require('video.js/dist/lang/zh-CN.js')
import Pagination from "@/components/Pagination";

import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
Vue.component(CollapseTransition.name, CollapseTransition)

Vue.use(VideoPlayer)
Vue.use(MetaInfo);
Vue.use(ElementUI);

Vue.prototype.$api = api

// 自定义组件名
// Vue.component('happy-scroll', HappyScroll)
// Vue.component('Pagination', Pagination)
// 引入css
// import 'vue-happy-scroll/docs/happy-scroll.css'

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
